import React, {createContext} from 'react';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
export const MarketDataContext = createContext();

var apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

class MarketDataContextProvider extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            pipId:this.getPathVar('pip'),
            pipData : [],
            sales: [],
            rosData : [],
            message: {},
            stats:{},
            tableMap:[],
            budgetPlannerData:[],
            budgetPlannerDataDefault:[],
            dataUpdate:[],
            doResetButton : false,
            doUpdateButton: false,
            isLoading: true,
            showProgressBar : false,
            progressBarProgress : 0,
            magneticHighlights : []
        };


    }
    componentDidMount(){
        this.getPipData();
        this.readMarketData();
        this.readBudgetPlanner();
    }


    getPathVar(name){
        var pathParts = window.location.pathname.split('/');
        for(var i=0; i<pathParts.length; i++){
            if(pathParts[i] === name){
                if(pathParts[i+1] !== undefined){
                    return pathParts[i+1];
                }
            }
        }
        return '';
    }




    readBudgetPlanner(){
        if(this.state.pipId){
            axios.get(apiUrl+'/fcase/'+this.state.pipId+'/budgetplanner',{
                withCredentials:true
            }).then(response => {

                let budgetData = response.data;

                let budgetKeys = [
                    'current_property_valuation',
                    'existing_mortgage',
                    'second_mortgage',
                    'additional_deductions',
                    'formPurchasePrice',
                    'mortgageLevel',
                    'additional_deductions',
                    'additional_cash'
                ];



                for(var i in budgetKeys){
                    if(budgetData.formData[budgetKeys[i]] === null){
                        budgetData.formData[budgetKeys[i]] = 0;
                    }
                    else{
                        if(typeof budgetData.formData[budgetKeys[i]]  === 'string'){
                            budgetData.formData[budgetKeys[i]] = 1 * budgetData.formData[budgetKeys[i]].replace(/\D/g,'');
                        }
                    }
                }
                console.log(budgetData.formData);



                // Whether this is a sale + purchase (vs purchase-only) planner comes
                // from the backend's explicit `purchaseOnly` flag. Only fall back to the
                // old "saleFees > 0" heuristic if an older API response omits it — that
                // heuristic wrongly flips to purchase-only whenever the fee figures fail
                // to parse (see grabBudgetPlannerData).
                let isSale = (typeof budgetData.purchaseOnly !== 'undefined')
                    ? !budgetData.purchaseOnly
                    : (budgetData.feeTotals.saleFees > 0);

                budgetData.saleBalance = 0;
                budgetData.saleBalance += budgetData.formData.current_property_valuation;
                budgetData.saleBalance -= budgetData.formData.existing_mortgage;
                budgetData.saleBalance -= budgetData.formData.second_mortgage;
                budgetData.saleBalance -= budgetData.feeTotals.saleFees;
                budgetData.saleBalance -= budgetData.feeTotals.saleOutlays;
                budgetData.saleBalance -= budgetData.formData.additional_deductions;
                budgetData.saleBalanceAbs = Math.abs(budgetData.saleBalance);

                //additional deductions should go here, this is a todo
                budgetData.purchaseBalance = 0;
                budgetData.purchaseBalance -= budgetData.formData.formPurchasePrice;
                budgetData.purchaseBalance += budgetData.formData.mortgageLevel;
                budgetData.purchaseBalance -= budgetData.feeTotals.purchaseFees;
                budgetData.purchaseBalance -= budgetData.feeTotals.purchaseOutlays;
                budgetData.purchaseBalance += budgetData.formData.additional_cash;
                if(isSale){
                    budgetData.purchaseBalance += budgetData.saleBalance;
                }
                if(!isSale && budgetData.formData.is_fhf !== 0){
                    budgetData.purchaseBalance += budgetData.formData.first_home_fund;
                }

                budgetData.purchaseBalanceAbs = Math.abs(budgetData.purchaseBalance);

                budgetData.doSale = isSale;
                this.setState({
                    budgetPlannerData : budgetData,
                    budgetPlannerDataDefault : cloneDeep(budgetData),
                    showProgressBar : false
                });
            });
        }
    }


    //read
    readMarketData() {

        if(this.state.pipId > 0) {


            var sellingPrices = [];
            var overHr = [];
            var overAsking = [];
            var days = [];
            var sqmP = [];
            const average = arr => arr.reduce( ( p, c ) => p + c, 0 ) / arr.length;

            axios.get(apiUrl+'/marketdata/'+this.state.pipId,{
                withCredentials:true
            })
                .then(response => {

                    //parse the data
                    for(var i in response.data.sales){
                        response.data.sales[i].sqmP = 0;
                        if(response.data.sales[i].sellingPrice > 0) {
                            sellingPrices.push(response.data.sales[i].sellingPrice);
                        }
                        if(response.data.sales[i].sellingPrice > 0 && response.data.sales[i].hRValue > 0){
                            response.data.sales[i].overHR = Math.round((((response.data.sales[i].sellingPrice/response.data.sales[i].hRValue)-1)*100));
                            overHr.push(response.data.sales[i].sellingPrice/response.data.sales[i].hRValue);
                        }
                        if(response.data.sales[i].sellingPrice > 0 && response.data.sales[i].askingPrice > 0){
                            response.data.sales[i].overAsking = Math.round((((response.data.sales[i].sellingPrice/response.data.sales[i].askingPrice)-1)*100));
                            overAsking.push(response.data.sales[i].sellingPrice/response.data.sales[i].askingPrice);
                        }
                        if(response.data.sales[i].dateOnMarket !== undefined && response.data.sales[i].dateOnMarket !== null && response.data.sales[i].dateSold !== undefined){
                            var from = Date.parse(response.data.sales[i].dateOnMarket);
                            var to = Date.parse(response.data.sales[i].dateSold);
                            var diff = (to-from)/(1000 * 3600 * 24);
                            days.push(diff);
                        }
                        if(response.data.sales[i].sqm !== undefined){
                            if(response.data.sales[i].sqm > 0 && response.data.sales[i].hRValue > 0){
                                sqmP.push(response.data.sales[i].hRValue/response.data.sales[i].sqm)
                                response.data.sales[i].sqmP = response.data.sales[i].hRValue/response.data.sales[i].sqm;
                            }
                        }
                    }

                    console.log(overHr);
                    let maxOverHr = 0;
                    for(var i in overHr){
                        if(overHr[i] > maxOverHr){
                            maxOverHr = overHr[i];
                        }
                    }




                    this.setState({
                        sales: response.data.sales,
                        rosData: response.data.rosData,
                        stats:{
                            avgSqm:Math.round(average(sqmP)),
                            avgSelling:Math.round(average(sellingPrices)),
                            avgOverHr:(average(overHr)*100)-100,
                            avgOverAsking:(average(overAsking)*100)-100,
                            avgDays:Math.round(average(days)),
                            richMarketData: (overHr.length > 0 ? true : false),
                            maxOverHr: (maxOverHr*100)-100
                        },
                        isLoading: false,
                    });

                    console.log(this.state.stats);

                    //set the table map
                    this.offerTypeTable();




                }).catch(error => {
                console.error(error);
            });

        }
    }

    checkUpdateFields(){

        if(this.state.budgetPlannerData.feeTotals.saleFees > 0) {
            if (this.state.budgetPlannerData.formData.current_property_valuation <= 0) {
                return false;
            }
            if (this.state.budgetPlannerData.formData.existing_mortgage < 0) {
                return false;
            }
            if (this.state.budgetPlannerData.formData.second_mortgage < 0) {
                return false;
            }
        }
        if(this.state.budgetPlannerData.formData.formPurchasePrice <= 0){
            return false;
        }
        if(this.state.budgetPlannerData.formData.mortgageLevel < 0){
            return false;
        }
        return true;
    }

    checkUpdateButton(){
        this.setState({
            doUpdateButton : this.checkUpdateFields()
        });
    }


    updateData(target,value){
        let modFormData = this.state.budgetPlannerData;

        let parts = target.split('.');
        modFormData[parts[0]][parts[1]] = value.replace(/,/g, '');
        modFormData.feeTotals = {};
        modFormData.purchaseBalance = '';
        modFormData.saleBalance = '';
        this.setState({
            doResetButton : true
        });
        //check if the fields are valid before allowing the calculate button to run

        this.checkUpdateButton();
    }

    resetData(){
        this.setState({
            budgetPlannerData : cloneDeep(this.state.budgetPlannerDataDefault),
            doResetButton : false,
            doUpdateButton : false
        });
    }

    doCalculate(){
        this.setState({
            progressBarProgress : 0,
        });
        this.setState({
            showProgressBar : true,
            doResetButton : false,
            doUpdateButton : false,
        });
        let oldProgress = 0;
        const timer = setInterval(() => {
            if (oldProgress > 50) {
                clearInterval(timer);
            }
            const diff = Math.random() * 10;
            oldProgress = Math.min(oldProgress + diff, 100);
            this.setState({
                progressBarProgress : oldProgress
            });
        }, 500);


        let data = {
            current_property_valuation:this.state.budgetPlannerData.formData.current_property_valuation,
            existing_mortgage:this.state.budgetPlannerData.formData.existing_mortgage,
            second_mortgage:this.state.budgetPlannerData.formData.second_mortgage,
            proposed_purchase_price:this.state.budgetPlannerData.formData.formPurchasePrice,
            mortgage_level:this.state.budgetPlannerData.formData.mortgageLevel,
            first_home_fund:this.state.budgetPlannerData.formData.first_home_fund,
            additional_cash:this.state.budgetPlannerData.formData.additional_cash,
            additional_deductions:this.state.budgetPlannerData.formData.additional_deductions
        };

        axios.post(apiUrl+'/fcase/'+this.state.pipId+'/budgetplanner/update', data, {
            withCredentials:true,
            timeout: 60000}).then(r => {

                const timer = setInterval(() => {
                    if (oldProgress === 100) {
                        clearInterval(timer);
                    }
                    const diff = Math.random() * 10;
                    oldProgress = Math.min(oldProgress + diff, 100);
                    this.setState({
                        progressBarProgress : oldProgress
                    });
                }, 500);

                this.readBudgetPlanner();



        });




    }

    offerTypeTable(){

        const tableMap = [];
        const magneticHighlights = [];

        if(this.state.pipData !== null && this.state.sales.length >0) {

            let tableRows = 12;
            var incrementPerc = 2.5;
            var magicIncrement = 2500;
            var askingPriceUplift = 0;
            var hrValueUplift = 0;

            var hrTarget = Math.round((1+(this.state.stats.avgOverHr/100))*this.state.pipData.hrValue);

            let minPerc = (Math.floor((this.state.stats.avgOverAsking >  this.state.stats.avgOverHr ? this.state.stats.avgOverHr : this.state.stats.avgOverAsking)/incrementPerc)*incrementPerc);
            let maxPerc = (Math.ceil((this.state.stats.avgOverAsking >  this.state.stats.avgOverHr ? this.state.stats.avgOverAsking : this.state.stats.avgOverHr)/incrementPerc)*incrementPerc);

            let rows = ((maxPerc - minPerc)/incrementPerc) + 1;
            let minRow = minPerc - (Math.ceil((tableRows - rows)/2)*incrementPerc);

            minRow = (minRow === 0 ? 1 : minRow/incrementPerc);


            let lowMagicIncrement = hrTarget - (hrTarget % magicIncrement);
            let minMagic = lowMagicIncrement - (tableRows * magicIncrement/2);
            let minMagicAdder = minMagic - this.state.pipData.hrValue;

            let upliftRow = minRow;
            let hrInsert =0;
            let askingInsert =0;

            if(this.state.stats.richMarketData === false){
                upliftRow = 0;
                let s = this.state.stats;
                s.avgOverHr = 5;
                this.setState({
                    stats:s
                });
                minMagicAdder = 0;
                hrTarget = Math.round((1.05)*this.state.pipData.hrValue);

            }


            for (var j = 1; j < 13; j++) {

                askingPriceUplift = Math.round(this.state.pipData.askingPrice * (1 + (upliftRow * incrementPerc / 100)));
                hrValueUplift = Math.round(this.state.pipData.hrValue * (1 + (upliftRow * incrementPerc / 100)));
                let magicOffer = (this.state.pipData.hrValue*1) + minMagicAdder + (j * magicIncrement);

                tableMap.push({
                    magneticNumber: minMagicAdder + (j * magicIncrement),
                    magneticNumberOffer: magicOffer,
                    magneticHightlight: (Math.abs(hrTarget - magicOffer) < magicIncrement),
                    uplift: (upliftRow * 2.5),
                    upliftHighlight:false,
                    askingPriceUplift: askingPriceUplift,
                    hrValueUplift: hrValueUplift
                });

                if(Math.abs(hrTarget - magicOffer) < magicIncrement){
                    magneticHighlights.push(magicOffer);
                }

                if(Math.round(this.state.pipData.hrValue * (1 + ((upliftRow+1) * incrementPerc / 100))) > hrTarget && hrInsert === 0){
                    hrInsert = 1;
                }
                if(Math.round(this.state.pipData.askingPrice * (1 + ((upliftRow+1) * incrementPerc / 100))) > hrTarget && askingInsert === 0){
                    askingInsert = 1;
                }

                if(this.state.pipData.hrValue >= this.state.pipData.askingPrice) {

                    if (hrInsert === 1) {
                        hrInsert = 2;
                        tableMap.push({
                            magneticNumber: '',
                            magneticNumberOffer: 0,
                            magneticHightlight: false,
                            uplift: this.state.stats.avgOverHr,
                            upliftHighlight: true,
                            askingPriceUplift: '',
                            hrValueUplift: hrTarget
                        });
                    }

                    if (askingInsert === 1) {
                        askingInsert = 2;
                        /*
                        tableMap.push({
                            magneticNumber: '',
                            magneticNumberOffer: 0,
                            magneticHightlight: false,
                            uplift: (hrTarget / this.state.pipData.askingPrice * 100) - 100,
                            upliftHighlight: true,
                            askingPriceUplift: hrTarget,
                            hrValueUplift: ''
                        });
                        */

                    }

                }
                else{
                    if (askingInsert === 1) {
                        askingInsert = 2;
                        /*
                        tableMap.push({
                            magneticNumber: '',
                            magneticNumberOffer: 0,
                            magneticHightlight: false,
                            uplift: (hrTarget / this.state.pipData.askingPrice * 100) - 100,
                            upliftHighlight: true,
                            askingPriceUplift: hrTarget,
                            hrValueUplift: ''
                        });
                        */

                    }

                    if (hrInsert === 1) {
                        hrInsert = 2;
                        tableMap.push({
                            magneticNumber: '',
                            magneticNumberOffer: 0,
                            magneticHightlight: false,
                            uplift: this.state.stats.avgOverHr,
                            upliftHighlight: true,
                            askingPriceUplift: '',
                            hrValueUplift: hrTarget
                        });
                    }
                }



                upliftRow++;

            }
            this.setState({
                tableMap:tableMap,
                magneticHighlights:magneticHighlights
            })
        }


        return tableMap;
    }


    async getPipData(){
        await axios.get(apiUrl+'/client/pips',{
            withCredentials:true
        })
            .then(response => {
                for(var i in response.data){
                   if(response.data[i].fcase_id === this.state.pipId){

                       let pData = response.data[i];
                       pData.sqmP = 0;
                       if((pData.sqm+0) > 0 && (pData.hrValue+0) > 0){
                           pData.sqmP = pData.hrValue/pData.sqm;
                       }

                       this.setState({
                           pipData: pData,
                       });
                   }
                }
                this.offerTypeTable();
            }).catch(error => {
            console.error(error);
        });
    }

    outputDate(str){
        if(str !== undefined){
            return (new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "long",
                day: "2-digit"
            }).format(new Date(str)));
        }
        else{
            return '';
        }
    }

    outputCurrency(str){
        if(str > 0){
            return  (new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            })).format(str);
        }
    }



    render() {
        return (
            <MarketDataContext.Provider value={{
                ...this.state,
                outputDate: this.outputDate.bind(this),
                outputCurrency: this.outputCurrency.bind(this),
                updateData :this.updateData.bind(this),
                resetData : this.resetData.bind(this),
                doCalculate : this.doCalculate.bind(this),
                setMessage: (message) => this.setState({message: message}),
            }}>
                {this.props.children}
            </MarketDataContext.Provider>
        );
    }
}

export default MarketDataContextProvider;